import { FC, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { RouterPaths } from '../../helpers/router-paths';
import withContainer from 'components/Container/withContainer';
import { UserContext } from '../../context/User';

const LogoutPage: FC = () => {
    const navigate = useNavigate();
    const { logout } = useContext(UserContext);

    useEffect(() => {
        logout().then(() => {
            navigate(RouterPaths.Auth, {
                unstable_viewTransition: true
            });
        });
    }, [navigate, logout]);

    return <>Выход из системы...</>;
};

export default withContainer(LogoutPage, { checkEmailConfirm: false });
